import { css } from "@emotion/react";
import { styled } from "@mui/material";
import { pxToRem } from "../../design/utils";
import { FlexRowContainer } from "../bits/layout";

export const FilterHeader = styled(FlexRowContainer)<{ hasRelated?: boolean }>(
  ({ theme, hasRelated }) => css`
    padding-left: ${theme.spacing(1)};
    height: ${hasRelated ? "auto" : pxToRem(44)};
    ${theme.layers.relief.uiGrey_10.shadow};

    ${hasRelated
      ? `justify-content: space-evenly;
        flex-direction: column;
    align-items: flex-start;    `
      : `justify-content: space-between;`}

    position: sticky;
    top: 0;
    z-index: 1;

    @media (max-width: ${theme.breakpoints.values.md}px) {
      height: max-content;
      padding-bottom: ${theme.spacing(0.5)};
      padding-top: ${theme.spacing(0.5)};
      padding-left: ${theme.spacing(0.5)};
    }
  `,
);
